import {ViesHttpClient} from "../http-clients/ViesHttpClient";

export class ResolveNIP {

    /**
     * @param {String} nip
     * @returns {String|boolean}
     */
    validateNIP(nip)
    {
        if (nip == null) return false;

        nip = nip.replace(/\ /g, '');
        nip = nip.replace(/:/gi, '');
        nip = nip.replace(/-/gi, '');
        nip = nip.replace(/PL/gi, '');

        if (nip.length !== 10) return false;

        for (let i=0; i<10; i++) {
            if (isNaN(nip[i])) return false;
        }

        let sum = 6 * nip[0] + 5 * nip[1] + 7 * nip[2] + 2 * nip[3] + 3 * nip[4] + 4 * nip[5] + 5 * nip[6] + 6 * nip[7] + 7 * nip[8];
        sum %= 11;

        if (nip[9] != sum) return false;

        return nip;
    }

    /**
     * @param {Object} inputNIP
     */
    checkNIP(inputNIP)
    {
        const nip = this.validateNIP(inputNIP.value);

        if (nip !== false) {
            document.getElementById('uwaga_nip').innerHTML='<span class="koszyk_smalllabel">NIP</span> <span class="round-button">OK</span>';
            inputNIP.value=nip;

            inputNIP.classList.remove('czerwona_ramka');
        } else {
            document.getElementById('uwaga_nip').innerHTML='<font class="koszyk_smalllabel" color="#ff0000">NIP jest prawdopodobnie błędny, prosimy o sprawdzenie.</font>';

            inputNIP.classList.add('czerwona_ramka');
        }
    }

    /**
     * @param {String} elementName
     */
    initialize(elementName)
    {
        this.inputNip = document.querySelector(elementName);
        if (null != this.inputNip) {

            this.inputNip.addEventListener('blur', async (event) => {
                event.preventDefault();

                const selectorCountry = document.querySelector('select#d_delivery_country');
                if (null != selectorCountry && selectorCountry.value === 'Polska') {
                    this.checkNIP(this.inputNip);
                }

                const selectorCountryProfil = document.querySelector('select#u_comapny_country');
                if (null != selectorCountryProfil && selectorCountryProfil.value === 'Polska') {
                    this.checkNIP(this.inputNip);
                }

                await this.eventBlur();
            });
        }

        return this;
    }

    /**
     * @param {String} country
     */
    async eventBlur(country = '') {
        if (this.inputNip === null) {
            return this;
        }
        if (this.inputNip.value === '') {
            let label = document.getElementById('uwaga_nip');
            if (label) {
                label.innerHTML = '<span class="koszyk_smalllabel">NIP *</span>';
            }
            this.inputNip.classList.remove('czerwona_ramka');

            return this;
        }

        const selectorCountry = document.querySelector('select#d_delivery_country');
        if (null != selectorCountry) {
            country = selectorCountry.value;
        }

        const selectorCountryProfil = document.querySelector('select#u_comapny_country');
        if (null != selectorCountryProfil) {
            country = selectorCountryProfil.value;
        }

        if (country === 'Polska') {
            this.checkNIP(this.inputNip);
        }

        let response = false;
        const client = new ViesHttpClient();

        try {
            response = await client.check(this.inputNip.value);
            if (response !== false) {
                document.getElementById('uwaga_nip').innerHTML='<span class="koszyk_smalllabel">NIP</span> <strong>VIES</strong>';
                this.inputNip.classList.remove('czerwona_ramka');
            }
        } catch (error) {
        }

        return this;
    }
}
